import SermonSearch from "./components/SermonSearch";
import Sermons from "./components/Sermons";

const App = () => {
    return (
        <div className="container top-content-section">
            <h1 className="sermons-green-text large-text wide-letter-spacing bolder-font text-uppercase">Search Sermons</h1>
            <SermonSearch />
            <Sermons />
        </div>
    );
}

export default App;
